import { useEffect } from "react";

const BRAND_SUFFIX = "Natur Autoescuela";

/**
 * Sets `document.title` to `${title} · Natur Autoescuela` while the component
 * is mounted, and restores the previous title on unmount.
 * Pass an empty string to use just the brand name.
 */
export default function useDocumentTitle(title) {
  useEffect(() => {
    const previous = document.title;
    document.title = title ? `${title} · ${BRAND_SUFFIX}` : BRAND_SUFFIX;
    return () => {
      document.title = previous;
    };
  }, [title]);
}
